const badge = `<a href="https://codemineapp.com" target="_blank" rel="noopener noreferrer" style="position: fixed; bottom: 15px; right: 15px; display: flex; align-items: center; padding: 6px 12px; background-color: rgba(17, 24, 39, 0.8); color: #f9fafb; text-decoration: none; font-family: sans-serif; font-size: 12px; border-radius: 8px; z-index: 10000; backdrop-filter: blur(5px); border: 1px solid rgba(255, 255, 255, 0.1);"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 8px;"><path d="M12 2L2 7V17L12 22L22 17V7L12 2ZM12 12.33L5.5 8.67L12 5L18.5 8.67L12 12.33ZM12 14.5L18.5 10.83V16.33L12 20V14.5ZM5.5 10.83L12 14.5V20L5.5 16.33V10.83Z" fill="#8b5cf6"></path></svg><span>Made with Codemine</span></a>`;

const createPlaceholder = (title: string, bgColor: string, textColor: string) => `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>${title} Preview</title>
    <style>
        body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; display: flex; align-items: center; justify-content: center; height: 100vh; background-color: ${bgColor}; color: ${textColor}; }
        .container { text-align: center; padding: 2rem; border: 2px dashed ${textColor}; border-radius: 12px; }
        h1 { font-size: 2.5rem; margin-bottom: 0.5rem; }
        p { font-size: 1.2rem; }
    </style>
</head>
<body>
    <div class="container">
        <h1>${title}</h1>
        <p>Live preview coming soon!</p>
    </div>
    ${badge}
</body>
</html>
`;

const auraPreview = `
<!DOCTYPE html>
<html lang="en" style="scroll-behavior: smooth;">
<head>
    <meta charset="UTF-8"><meta name="viewport" content="width=device-width, initial-scale=1.0">
    <script src="https://cdn.tailwindcss.com"></script>
    <style>@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;600;700&display=swap'); body { font-family: 'Poppins', sans-serif; }</style>
    <title>Aura Apparel Preview</title>
</head>
<body class="bg-gray-50 text-gray-800">
    <header class="border-b sticky top-0 bg-white/80 backdrop-blur-lg z-10">
        <nav class="container mx-auto px-6 py-4 flex justify-between items-center">
            <a href="#home" class="text-2xl font-bold tracking-wider">AURA</a>
            <div class="space-x-8 hidden md:flex">
                <a href="#home" class="hover:text-gray-500">Home</a>
                <a href="#shop" class="hover:text-gray-500">Shop</a>
                <a href="#about" class="hover:text-gray-500">About</a>
                <a href="#contact" class="hover:text-gray-500">Contact</a>
            </div>
            <a href="#shop"><svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" /></svg></a>
        </nav>
    </header>
    <main>
        <section id="home" class="h-[60vh] md:h-[90vh] bg-cover bg-center flex items-center justify-center text-center" style="background-image: url('https://images.unsplash.com/photo-1445205170230-053b83016050?q=80&w=2071&auto=format&fit=crop');">
            <div class="bg-black/40 p-8 rounded-lg">
                <h2 class="text-4xl md:text-6xl font-bold text-white mb-4">Timeless Style, Redefined</h2>
                <p class="text-lg text-white font-medium mb-6">Discover our new fall collection.</p>
                <a href="#shop" class="px-8 py-3 bg-white text-gray-800 font-semibold rounded hover:bg-gray-200 transition-colors">Shop Now</a>
            </div>
        </section>
        
        <section id="shop" class="py-20">
            <div class="container mx-auto px-6">
                <h3 class="text-3xl font-bold text-center mb-12">Our Collection</h3>
                <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                    <div class="bg-white rounded-lg shadow-sm overflow-hidden group"><img src="https://images.unsplash.com/photo-1594633312681-425c7b97ccd1?q=80&w=1974&auto=format&fit=crop" alt="Fashion item" class="w-full h-96 object-cover group-hover:scale-105 transition-transform duration-300"/></div>
                    <div class="bg-white rounded-lg shadow-sm overflow-hidden group"><img src="https://images.unsplash.com/photo-1551803091-e25622d2226a?q=80&w=1974&auto=format=fit&crop" alt="Fashion item" class="w-full h-96 object-cover group-hover:scale-105 transition-transform duration-300"/></div>
                    <div class="bg-white rounded-lg shadow-sm overflow-hidden group"><img src="https://images.unsplash.com/photo-1542295669-721536399324?q=80&w=1974&auto=format=fit&crop" alt="Fashion item" class="w-full h-96 object-cover group-hover:scale-105 transition-transform duration-300"/></div>
                    <div class="bg-white rounded-lg shadow-sm overflow-hidden group"><img src="https://images.unsplash.com/photo-1525455242988-1f310f54b683?q=80&w=1974&auto=format=fit&crop" alt="Fashion item" class="w-full h-96 object-cover group-hover:scale-105 transition-transform duration-300"/></div>
                </div>
            </div>
        </section>
        <section id="about" class="py-20 bg-white">
             <div class="container mx-auto px-6 text-center max-w-4xl">
                <h3 class="text-3xl font-bold mb-4">About Aura</h3>
                <p class="text-gray-600">We believe in creating timeless pieces that are designed to last. Our collections are crafted with quality materials and a minimalist aesthetic, perfect for the modern wardrobe.</p>
             </div>
        </section>
        <section id="contact" class="py-20">
             <div class="container mx-auto px-6 text-center max-w-xl">
                <h3 class="text-3xl font-bold mb-4">Contact Us</h3>
                <p class="text-gray-600 mb-8">Have a question? We'd love to hear from you.</p>
                <form class="space-y-4">
                    <input type="email" placeholder="Your Email" class="w-full p-3 border rounded"/>
                    <textarea placeholder="Your Message" rows="4" class="w-full p-3 border rounded"></textarea>
                    <button type="submit" class="px-8 py-3 bg-gray-800 text-white font-semibold rounded hover:bg-gray-700 transition-colors">Send Message</button>
                </form>
             </div>
        </section>
    </main>
    <footer class="bg-gray-100 py-8 text-center text-gray-600">
        <p>&copy; ${new Date().getFullYear()} Aura Apparel. All rights reserved.</p>
    </footer>
    ${badge}
</body>
</html>
`;

export const templatePreviews = {
  'aura-apparel': auraPreview,
  'gadget-hub': createPlaceholder('Gadget Hub', '#111827', '#F3F4F6'),
  'artisan-home': createPlaceholder('Artisan Home', '#FDFBF6', '#3C2A21'),
  'glow-skincare': createPlaceholder('Glow Skincare', '#FEFBF6', '#E6A4B4'),
  'voyagers-post': createPlaceholder("The Voyager's Post", '#F5F7FA', '#2C3E50'),
  'devfolio-portfolio': createPlaceholder('DevFolio', '#0D1117', '#C9D1D9'),
  'gilded-spoon-restaurant': createPlaceholder('The Gilded Spoon', '#0C0C0C', '#DCCA87'),
  'fit-forge-gym': createPlaceholder('FitForge', '#1A1A1A', '#FFFFFF'),
};